module.exports = {
    templateUrl: 'patterns/components/background-pattern-02.html'
};